import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ReportAllRecordsImage } from './models/template.model';

@Injectable()
export class ReportImagesService implements OnDestroy {
  onUpdateAdditionalImage$: Observable<any>;

  private _onUpdateAdditionalImage = new BehaviorSubject({});

  constructor() {
    this.onUpdateAdditionalImage$ = this._onUpdateAdditionalImage.asObservable();
  }

  ngOnDestroy(): void {
    this._onUpdateAdditionalImage.complete();
  }

  /**
   * @param reportImages type of @ReportAllRecordsImage that contains the record with with additional image id's.
   * which will trigger when there is change in particular record like add/ edit/ delete.
   */
  setReportRecordImages(reportImages: ReportAllRecordsImage) {
    this._onUpdateAdditionalImage.next({ ...reportImages });
  }
}
